const navItems = document.querySelectorAll('.nav-item');
const megaMenuHover = document.querySelector('.product-mega-menu-parent');
const megaMenu = document.querySelector('.product-mega-menu');
const navMenuItems = document.querySelectorAll('.nav-item');
const amsLogo = document.querySelectorAll('header .logo-container g g:first-child path'); 
const header = document.querySelector('header.main-header');

if (megaMenuHover) {
    megaMenuHover.addEventListener('mouseover', function () {
        megaMenu.classList.add('active');
        if (megaMenu.classList.contains('active')) {
            header.classList.add('scrolled-header');
            navMenuItems.forEach(item => {
                item.classList.add('white-bg');
            });
            amsLogo.forEach(item => {
                item.style.fill = '#283343';
            });
        }
    });

    navItems.forEach(item => {
        if (item !== megaMenuHover) {
            item.addEventListener('mouseover', function() {
                megaMenu.classList.remove('active');
                if (window.scrollY === 0) {
                    header.classList.remove('scrolled-header');
                    navMenuItems.forEach(navItem => {
                        navItem.classList.remove('white-bg');
                    });
                    amsLogo.forEach(logo => {
                        logo.style.fill = '#FFF';
                    });
                }
            });
        }
    });

    megaMenu.addEventListener('mouseleave', function () {
        megaMenu.classList.remove('active');
        if (window.scrollY === 0) { 
            header.classList.remove('scrolled-header');
            navMenuItems.forEach(item => {
                item.classList.remove('white-bg');
            });
            amsLogo.forEach(item => {
                item.style.fill = '#FFF';
            });
        }
    });
}

